/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * Styled components for widgets
 *
 * @author Fedorov Maxim
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.10.0
 * @since 1.0.1
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../../theme';

export const WidgetListStyled = styled.ul`
    padding: 0;
    margin: 0 0 24px;
    list-style: none;
`;

export const WidgetListItem = styled.li`
    display:flex;
    justify-content: space-between;
    margin-bottom: 16px;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const WidgetTitleStyled = styled.div.attrs({
    className: 'widget__title',
})`
    ${fonts.textHeader3};
    margin-bottom: 0;
`;

export const WidgetSubtitleStyled = styled.div.attrs({
    className: 'widget__subtitle',
})`
    margin-top: 4px;
`;

export const WidgetEmptyCircleStyled = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 73px;
    height: 72px;
    margin: 16px 0;
    background: ${colors.pageDashboardWidgetCircleBgColor};
    border-radius: 100px;
`;

export const WidgetSuccessStyled = styled.div`
    flex-grow: 1;
    line-height: 1.6;
`;

export const WidgetItemLeftContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: 200px;
`;

export const WidgetItemRightContainerStyled = styled.div`
    width: 115px;
    text-align: right;
`;
